"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultLayout = exports.getLayout = exports.saveLayout = exports.seenMessage = exports.readMessage = exports.readAlert = exports.createAlert = exports.removeFile = exports.providerWidget = exports.clearalerts = exports.loadbackorderdata = exports.paymentWidget = exports.testmailmessage = exports.dispensedStats = exports.claimStats = void 0;
const endpoint_1 = require("api/endpoint");
const permissions_1 = require("shared/permissions");
exports.claimStats = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_READ,
    method: "post",
    path: "dashboard/claimStats"
});
exports.dispensedStats = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_READ,
    method: "post",
    path: "dashboard/dispensedStats"
});
exports.testmailmessage = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "get",
    path: "dahboard/testmailmessage"
});
// C-097 Outstanding Payments
exports.paymentWidget = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "get",
    path: "dashboard/paymentWidget",
    query: {
        count: "number.required",
        order: { type: "string.optional", values: ["ASC", "DESC"] },
        sort: "string.optional",
        start: "number.optional",
        totalPages: "number.required",
        currentPage: "number.required"
    }
});
exports.loadbackorderdata = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "get",
    path: "dashboard/loadbackorderdata"
});
exports.clearalerts = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "put",
    path: "dashboard/clearalerts"
});
exports.providerWidget = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PROVIDER_READ,
    method: "post",
    path: "dashboard/providerWidget"
});
exports.removeFile = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PROVIDER_DELETE,
    method: "post",
    path: "provider/removeFile",
    tokens: { id: "number.required" }
});
exports.createAlert = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_CREATE,
    method: "post",
    path: "provider/createAlert"
    // tokens: { id: 'number.required' },
});
exports.readAlert = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_READ,
    method: "post",
    path: "provider/readAlert"
    // tokens: { id: 'number.required' },
});
exports.readMessage = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_READ,
    method: "post",
    path: "provider/readMessage"
    // tokens: { id: 'number.required' },
});
exports.seenMessage = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_CLAIM_READ,
    method: "post",
    path: "provider/seenMessage"
    // tokens: { id: 'number.required' },
});
exports.saveLayout = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "post",
    path: "dashboard/saveLayout"
});
exports.getLayout = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "post",
    path: "dashboard/getLayout"
});
exports.defaultLayout = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "post",
    path: "dashboard/defaultLayout"
});



//////////////////
// WEBPACK FOOTER
// ./src/api/dashboard/dashboard-client.ts
// module id = 982
// module chunks = 0 1 2